import { ForwardedRef, forwardRef, InputHTMLAttributes, useEffect, useLayoutEffect, useRef } from 'react'
import { clsx } from 'clsx'

import styles from './TextArea.module.scss'

export type Props = {
    counter?: boolean
    maxLength?: number
} & InputHTMLAttributes<HTMLTextAreaElement>

export const TextArea = forwardRef(
    ({ counter, maxLength, value, className, ...props }: Props, ref: ForwardedRef<HTMLTextAreaElement>) => {
        const internalRef = useRef<HTMLTextAreaElement | null>(null)

        const setRefs = (el: HTMLTextAreaElement) => {
            internalRef.current = el
            if (typeof ref === 'function') {
                ref(el)
            } else if (ref) {
                ref.current = el
            }
        }

        useLayoutEffect(() => {
            const el = internalRef.current

            if (el && el.scrollHeight) {
                el.style.height = 'auto'
                el.style.height = `${el.scrollHeight}px`
            }
        }, [value])

        useEffect(() => {
            internalRef.current?.blur()
        }, [])

        return (
            <div className={clsx(styles.root, className)}>
                <textarea {...props} maxLength={maxLength} value={value} className={styles.textarea} ref={setRefs} />
                {!!maxLength && !!counter && (
                    <p className={styles.counter}>
                        ({(value || '').toString().length}/{maxLength})
                    </p>
                )}
            </div>
        )
    }
)
